import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcEmptyList = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 140,
	height: 140,
	viewBox: "0 0 140 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M93.3855 43.3028C96.434 43.3028 98.9053 40.8315 98.9053 37.783C98.9053 34.7345 96.434 32.2632 93.3855 32.2632C90.3371 32.2632 87.8658 34.7345 87.8658 37.783C87.8658 40.8315 90.3371 43.3028 93.3855 43.3028ZM93.3855 46.2213C98.0459 46.2213 101.824 42.4433 101.824 37.783C101.824 33.1227 98.0459 29.3447 93.3855 29.3447C88.7252 29.3447 84.9473 33.1227 84.9473 37.783C84.9473 42.4433 88.7252 46.2213 93.3855 46.2213Z",
			fill: "#A9AFBB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M119.531 36.4449C119.773 35.6582 119.331 34.8243 118.544 34.5824C117.758 34.3405 116.924 34.7822 116.682 35.5689L115.108 40.6879L110.216 39.1837C109.429 38.9418 108.595 39.3834 108.354 40.1701C108.112 40.9569 108.553 41.7907 109.34 42.0326L114.232 43.5369L112.958 47.6782C112.716 48.4649 113.158 49.2988 113.945 49.5407C114.731 49.7826 115.565 49.341 115.807 48.5542L117.081 44.4129L121.449 45.7563C122.236 45.9982 123.07 45.5565 123.312 44.7698C123.554 43.9831 123.112 43.1492 122.325 42.9073L117.957 41.564L119.531 36.4449Z",
			fill: "#DFE3EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M116.682 35.5689C116.924 34.7822 117.758 34.3405 118.544 34.5824C119.331 34.8243 119.773 35.6582 119.531 36.4449L117.957 41.564L122.325 42.9073C123.112 43.1492 123.554 43.9831 123.312 44.7698C123.07 45.5565 122.236 45.9982 121.449 45.7563L117.081 44.4129L115.807 48.5542C115.565 49.341 114.731 49.7826 113.945 49.5407C113.158 49.2988 112.716 48.4649 112.958 47.6782L114.232 43.5369L109.34 42.0326C108.553 41.7907 108.112 40.9569 108.354 40.1701C108.595 39.3834 109.429 38.9418 110.216 39.1837L115.108 40.6879L116.682 35.5689Z",
			fill: "#A9AFBB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M111.915 21.0798C111.673 19.3309 109.414 18.7825 108.397 20.2257L107.892 20.9425C107.581 21.3832 107.102 21.6752 106.568 21.7491L105.699 21.8693C103.951 22.1112 103.402 24.37 104.845 25.387L105.562 25.8922C106.003 26.2027 106.295 26.6821 106.369 27.216L106.489 28.0848C106.731 29.8336 108.99 30.3821 110.007 28.9389L110.512 28.222C110.822 27.7814 111.302 27.4893 111.836 27.4155L112.704 27.2953C114.453 27.0534 115.002 24.7945 113.559 23.7775L112.842 23.2724C112.401 22.9619 112.109 22.4825 112.035 21.9485L111.915 21.0798Z",
			fill: "#A9AFBB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1748 57.7141C21.1748 52.5885 25.3299 48.4333 30.4555 48.4333H75.0403C80.1659 48.4333 84.321 52.5885 84.321 57.7141V116.331C84.321 121.457 80.1659 125.612 75.0402 125.612H30.4555C25.3299 125.612 21.1748 121.457 21.1748 116.331V57.7141Z",
			fill: "#CED2DA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M72.1619 66.9964C72.1619 67.7652 71.5386 68.3885 70.7698 68.3885H34.1109C33.342 68.3885 32.7188 67.7652 32.7188 66.9964C32.7188 66.2275 33.342 65.6042 34.1109 65.6042H70.7698C71.5386 65.6042 72.1619 66.2275 72.1619 66.9964Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M60.561 76.2747C60.561 77.0435 59.9377 77.6668 59.1689 77.6668H34.1109C33.342 77.6668 32.7188 77.0435 32.7188 76.2747C32.7188 75.5058 33.342 74.8826 34.1109 74.8826H59.1689C59.9377 74.8826 60.561 75.5058 60.561 76.2747Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M60.561 85.5559C60.561 86.3248 59.9377 86.948 59.1689 86.948H34.1109C33.342 86.948 32.7188 86.3248 32.7188 85.5559C32.7188 84.7871 33.342 84.1638 34.1109 84.1638H59.1689C59.9377 84.1638 60.561 84.7871 60.561 85.5559Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.3066 111.583H17.1378C15.4917 111.583 14.1388 112.919 14.2449 114.562C14.6568 120.944 16.5765 124.083 21.1735 125.615H77.3034C77.3034 125.615 71.6315 122.779 70.487 114.557C70.2601 112.927 68.9527 111.583 67.3066 111.583Z",
			fill: "#A9AFBB"
		})
	]
});
export default SvgIcEmptyList;
